export const localOrderIdKey = (slug?: string) => (slug ? `_${slug}_order_id` : '_order_id')
export const localOrderKey = '_order'
export const localPurchasedOrderKey = (slug?: string) =>
  slug ? `_${slug}_purchased_order` : '_purchased_order'
export const localIsBuyNowKey = (slug?: string) => (slug ? `_${slug}_isbuynow` : '_isbuynow')
export const localIsPayingKey = (slug?: string) => (slug ? `_${slug}_ispaying` : '_ispaying')
export const localSourceEventKey = (slug?: string) =>
  slug ? `_${slug}_source_event` : '_source_event'
export const localShippingAddressKey = '_shipping'
export const lastPLabelItem = '_last_p_label_item_'
export const isPayingWithPaypalKey = 'is_paying_paypal'
export const sessionIdKey = '_local_session_id'
export const userIdKey = '_local_user_id'
export const stripeShippingAddressKey = '_stripe_shipping_address'
export const isShowOrderTaxKey = 'is_show_order_tax'
export const taxByMethodKey = 'tax_by_method'

export const stripePaymentConfirm = '_stripe_confirm'
export const localStripePaymentConfirmKey = (slug?: string) =>
  slug ? `_${slug}_stripe_confirm` : '_stripe_confirm'
export const localOtpOutKey = (slug?: string) => (slug ? `_${slug}_otpout` : '_otpout')
export const localpaymentTypeOrderKey = '_payment_type_order'

export const localIsCollectTax = '_is_collect_tax'
export const completeCard = '_is_complete_card'
export const localVisitTimeKey = '_visit_time'

export const expiredDiscountKey = 'is_expired_discount'
export const tokenBrKey = 'token_br'
export const minPriceThankyou = 'min_price_thankyou'
export const isApplePayActiveKey = 'is_apple_pay_active'
export const isApplePayAvailableLoadingKey = 'is_apple_pay_available_loading'
export const isGooglePayActive = 'is_google_pay_active'
export const hasUpsellKey = 'has_upsell'
export const maxQuantityDiscountKey = 'max_quantity_discount'
export const isNegativeMaxQuantityDiscountKey = 'is_negative_max_quantity_discount'
export const savedPaymentMethodKey = 'saved_payment_method'
export const createdPaymentMethodKey = 'created_payment_method'
export const premadeContactFormKey = 'is_premade_contact_form'
export const currentCheckoutStepKey = 'current_checkout_step'
export const appBuildKey = 'app_build'
export const storeConfigurationKey = 'store_configuration'

export enum CheckoutStep {
  CARD_INPUT = 1,
  ADDRESS_INPUT_AND_PAY = 2
}

export enum CheckoutFromSource {
  BUY_NOW = 'buy_it_now',
  MULTI_CART = 'multi_cart',
  FEED_CART_LAYOUT_TAPPED = 'feed_cart_layout_tapped',
  FEED_CART_LAYOUT_SWIPE = 'feed_cart_layout_swipe',
  SINGLE_CART = 'single_cart',
  NOTIFICATION = 'notification'
}

export const versionCookie = [
  'v13',
  'v14',
  'v141',
  'v142',
  'br1',
  'vx141',
  'v144',
  'e144',
  'v146',
  'a144',
  'c144',
  'a145',
  'b144',
  'ba10', // Add checked mark for verified buyer + Add checkmark on selection
  'ba11',
  'ba23',
  'bb23',
  'p144', // policy
  'd144',
  'o144',
  'g144',
  'r144',
  'l144',
  'i144',
  'x144', //base new
  'z144', //base new
  'k144', //base new
  'f144', //base new
  'y144', //base new
  'h144', //base new
  'vta1',
  'c145',
  'vta3',
  'vta31',
  'c146',
  'vta2',
  'usp1', //usp
  'usp2',
  'usp3',
  'usp4',
  'vcdn3',
  'acdn3',
  'vap1',
  'gp01a',
  'gp01b',
  'gp02',
  'vlz1',
  'vpo1',
  'vpl1',
  'vna2',
  'vli1',
  'vta4',
  'v145',
  'apv1', // Apple Pay
  'apv2', // Apple Pay,
  'apv21', // Apple Pay version base trên apv2
  'apv3', // New Apple Pay version for buy it now
  'm144', // New version base,
  'ab144', // New version base,
  'ac144', // New version base,
  'apv5', // enhanced version for Apple Pay,
  'apv6',
  'apv51',
  'a25v26',
  'b25v24',
  'f25v51',
  'f25v26',
  'f25v511',
  'f25v61',
  'f25v611',
  'f25v20',
  'f25v612',
  'f25v52',
  'f25v521',
  'f25v31'
]

export const listVersionUsp = ['usp1', 'usp2', 'usp3', 'usp4', 'p144', 'd144', 'v144']
export const gaExcludes = ['rosiedelight.com', 'maracharm.com']
export type showValueCD = 'NONE' | 'POPUP' | 'TEXT'

export const MOBILE_APP_EVENTS = Object.freeze({
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  CART_REMOVE_ITEM: 'CART_REMOVE_ITEM',
  CART_CHOOSE_QUANTITY: 'CART_CHOOSE_QUANTITY',
  CHECKOUT_ADDRESS_FIELD_TAPPED: 'CHECKOUT_ADDRESS_FIELD_TAPPED',
  CHECKOUT_ADDRESS_FIELD_FILLED: 'CHECKOUT_ADDRESS_FIELD_FILLED',
  CHECKOUT_CARD_PAY: 'CHECKOUT_CARD_PAY',
  CHECKOUT_CARD_INFO_TAPPED: 'CHECKOUT_CARD_INFO_TAPPED',
  CHECKOUT_CARD_INFO_FILLED: 'CHECKOUT_CARD_INFO_FILLED',
  CHECKOUT_PAYMENT_INFO_FILLED: 'CHECKOUT_PAYMENT_INFO_FILLED',
  ADD_PAYMENT_INFO: 'ADD_PAYMENT_INFO',
  INIT: 'INIT',
  COMPLETE_CHECKOUT_STRIPE: 'COMPLETE_CHECKOUT_STRIPE',
  CHECKOUT_EMAIL_FIELD_TAPPED: 'CHECKOUT_EMAIL_FIELD_TAPPED',
  CHECKOUT_EMAIL_FIELD_FILLED: 'CHECKOUT_EMAIL_FIELD_FILLED',
  BACK: 'BACK',
  CLOSE: 'CLOSE',
  CHECKOUT_APPLE_PAY_ACTIVE: 'CHECKOUT_APPLE_PAY_ACTIVE',
  CHECKOUT_APPLE_PAY_INACTIVE: 'CHECKOUT_APPLE_PAY_INACTIVE',
  BACK_TO_HOME: 'BACK_TO_HOME',
  CART_CHECKOUT_PAYPAL: 'CART_CHECKOUT_PAYPAL',
  CHECKOUT_PAYPAL_TAPPED: 'CHECKOUT_PAYPAL_TAPPED',
  COMPLETE_CHECKOUT_PAYPAL: 'COMPLETE_CHECKOUT_PAYPAL',
  CART_PROCEED_CHECKOUT: 'CART_PROCEED_CHECKOUT',
  UPDATE_CART: 'UPDATE_CART',
  CHECKOUT_VIEW_APPEAR: 'CHECKOUT_VIEW_APPEAR',
  CHECKOUT_VIEW_DISAPPEAR: 'CHECKOUT_VIEW_DISAPPEAR',
  CHECKOUT_APPLE_PAY_TAPPED: 'CHECKOUT_APPLE_PAY_TAPPED',
  REDIRECT_TO_CONTACT: 'REDIRECT_TO_CONTACT',
  REDIRECT_TO_ORDER_LIST: 'REDIRECT_TO_ORDER_LIST',
  INIT_CHECKOUT: 'INIT_CHECKOUT',
  SELECT_UPSELL: 'SELECT_UPSELL',
  CART_PAYPAL_CANCEL: 'CART_PAYPAL_CANCEL',
  CHECKOUT_PAYPAL_CANCEL: 'CHECKOUT_PAYPAL_CANCEL',
  UPSELL_SHOWN: 'UPSELL_SHOWN',
  ORDER_SUMMARY_TAPPED: 'ORDER_SUMMARY_TAPPED',
  CUSTOMER_INFO_TAPPED: 'CUSTOMER_INFO_TAPPED',
  SINGLE_CART_PAGE_LOADED: 'SINGLE_CART_PAGE_LOADED',
  CHECKOUT_PAGE_LOADED: 'CHECKOUT_PAGE_LOADED',
  PAYPAL_PAGE_UPSERTED_CART: 'PAYPAL_PAGE_UPSERTED_CART',
  PAYPAL_PAGE_UPDATED_TAX: 'PAYPAL_PAGE_UPDATED_TAX',
  CART_PAGE_APPEAR: 'CART_PAGE_APPEAR',
  CART_PAGE_DISAPPEAR: 'CART_PAGE_DISAPPEAR',
  SHIPPING_CHANGE: 'SHIPPING_CHANGE',
  CHECKOUT_BACK: 'CHECKOUT_BACK',
  CHECKOUT_CONTINUE_CARD_TAPPED: 'CHECKOUT_CONTINUE_CARD_TAPPED',
  CHECKOUT_SAVE_CARD: 'CHECKOUT_SAVE_CARD',
  CHECKOUT_CARD_VALIDATION_ERROR: 'CHECKOUT_CARD_VALIDATION_ERROR',
  CHECKOUT_CONSENT_TAPPED: 'CHECKOUT_CONSENT_TAPPED',
  CHECKOUT_TERMS_TAPPED: 'CHECKOUT_TERMS_TAPPED',
  CHECKOUT_REVIEW_VIEW: 'CHECKOUT_REVIEW_VIEW',
  CHECKOUT_REVIEW_VIDEO_IMPRESSION_START: 'CHECKOUT_REVIEW_VIDEO_IMPRESSION_START',
  CHECKOUT_REVIEW_VIDEO_IMPRESSION_END: 'CHECKOUT_REVIEW_VIDEO_IMPRESSION_END',
  CHECKOUT_SAVE_PAYMENT_FORCE_UPDATE: 'CHECKOUT_SAVE_PAYMENT_FORCE_UPDATE',
  CHECKOUT_APPLE_PAY_CANCEL: 'CHECKOUT_APPLE_PAY_CANCEL',
  CHECKOUT_PAYPAL_LOGGEDIN: 'CHECKOUT_PAYPAL_LOGGEDIN',
  CHANGE_PAYMENT_METHOD_TAPPED: 'CHANGE_PAYMENT_METHOD_TAPPED',
  CHANGE_SHIPPING_ADDRESS_TAPPED: 'CHANGE_SHIPPING_ADDRESS_TAPPED'
} as const)

export const whitelistDeviceIds = [
  '2892f848-b232-46f1-928e-93d2e9ed928b',
  'bad15af1-653f-450f-8bbc-d18ecadded6e'
]

export const stripePermanentErrorCodes = [
  'expired_card',
  'incorrect_number',
  'invalid_number',
  'incorrect_cvc',
  'processing_error'
]

export const stripeTemporaryErrorCodes = ['api_error', 'api_connection_error']

export const stripePermanentDeclineCodes = [
  'expired_card',
  'lost_card',
  'stolen_card',
  'do_not_try_again',
  'fraudulent',
  'pickup_card',
  'restricted_card',
  'revocation_of_all_authorizations',
  'revocation_of_authorization',
  'card_not_supported',
  'currency_not_supported',
  'merchant_blacklist',
  'stop_payment_order',
  'transaction_not_allowed'
]

export const stripeTemporaryDeclineCodes = [
  'insufficient_funds',
  'generic_decline',
  'authentication_required',
  'processing_error',
  'try_again_later',
  'call_issuer',
  'duplicate_transaction',
  'approve_with_id'
]

/**
 * if these fields are changed, we need to update the tax
 */
export const ADDRESS_FIELDS_TO_UPDATE_TAX = ['address1', 'address2', 'city', 'state', 'postal_code']

/**
 * these fields are required to calculate the tax, address2 is optional, country and country_code are fixed to US
 */
export const ADDRESS_FIELDS_TO_UPDATE_TAX_REQUIRED = [
  'address1',
  'city',
  'state',
  'postal_code',
  'country',
  'country_code'
]
